import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// const openedWindowIdsAtom = atomWithStorage<string[]>(
//   "openedWindowIds",
//   [],
//   undefined,
//   {
//     getOnInit: true,
//   }
// );

const openedWindowIdsAtom = atom<string[]>([]);

export default openedWindowIdsAtom;
